import { importLibrary, setOptions } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from "@googlemaps/markerclusterer"

const lightMapStyles = [
    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#d3d3d3" }] },
    { featureType: "transit", stylers: [{ color: "#808080" }, { visibility: "off" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ visibility: "on" }, { color: "#b3b3b3" }] },
    { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
    { featureType: "road.local", elementType: "geometry.fill", stylers: [{ visibility: "on" }, { color: "#ffffff" }, { weight: 1.8 }] },
    { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ color: "#d7d7d7" }] },
    { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "on" }, { color: "#ebebeb" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#a7a7a7" }] },
    { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
    { featureType: "landscape", elementType: "geometry.fill", stylers: [{ visibility: "on" }, { color: "#efefef" }] },
    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#696969" }] },
    { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ visibility: "on" }, { color: "#737373" }] },
    { featureType: "poi", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ color: "#d6d6d6" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "geometry.fill", stylers: [{ color: "#dadada" }] },
]

const darkMapStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
    { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
    { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#4a4a4a" }] },
    { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#a0a0a0" }] },
    { featureType: "landscape", elementType: "geometry.fill", stylers: [{ color: "#1d2c3b" }] },
]

export const setupGoogleApi = (apiKey) => {
    return {
        getLoader: () => {
            setOptions({
                key: apiKey,
                version: "weekly",
            })

            return {
                importLibrary,
            }
        },
        getMarkerClusterer: () => {
            return MarkerClusterer
        },
        getMapStyles: (isDark) => isDark ? darkMapStyles : lightMapStyles,
        defaultMapOptions: {
            center: { lat: 52.1326, lng: 5.2913 },
            zoom: 4,
            maxZoom: 18,
            styles: lightMapStyles,
        },
    }
}
